import { render, staticRenderFns } from "./UITickersDropdown.vue?vue&type=template&id=1fe7c1bf"
import script from "./UITickersDropdown.vue?vue&type=script&lang=js"
export * from "./UITickersDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports